import type { Product } from '@/shared/types/product';

/** Texto seguro para busca, ordenação e card. Nome vazio não pode derrubar a lista. */
export function productText(value: unknown): string {
  if (value == null) return '';
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return '';
}

export function productPoints(product: Product): number {
  const n = Number(product.value);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Resgate explícito. O checkbox antigo enviava `"S"`; a API só grava `true`
 * quando o corpo é boolean. O catálogo histórico fica com `false`.
 */
export function allowsRedemption(product: Product): boolean {
  const flag = product.redemption as unknown;
  if (flag === true || flag === 1 || flag === '1') return true;
  if (typeof flag === 'string') {
    const value = flag.trim().toLowerCase();
    return value === 'true' || value === 's' || value === 'sim';
  }
  return false;
}

/**
 * `GET /products/:id/true` é o catálogo inteiro.
 * Resgates fica com o flag de resgate ligado; Produtos, com o resto.
 */
export function scopeCatalog(products: Product[], mode: 'product' | 'redemption'): Product[] {
  const rows = products.filter((product) => product != null);
  if (mode === 'redemption') return rows.filter(allowsRedemption);
  return rows.filter((product) => !allowsRedemption(product));
}

export function matchesProductSearch(product: Product, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [product.name, product.uniqueId, product.redemptionType].some((value) =>
    productText(value).toLowerCase().includes(q),
  );
}

export function compareProducts(sortValue: string, a: Product, b: Product): number {
  if (sortValue === 'name:desc') return productText(b.name).localeCompare(productText(a.name), 'pt-BR');
  if (sortValue === 'value:desc') return productPoints(b) - productPoints(a);
  if (sortValue === 'value:asc') return productPoints(a) - productPoints(b);
  return productText(a.name).localeCompare(productText(b.name), 'pt-BR');
}
